import React, { useState, useEffect } from 'react';
import MyCardsNavbar from 'components/dashboard/MyCardsNavbar';
import ProgressUI from 'components/dashboard/ProgressUI';
import CardsContainer from 'components/dashboard/CardsContainer';
import NotificationSnackbar from 'components/common/notification/NotificationSnackbar';
import { useNavigate, useLocation } from 'react-router-dom';
import { useCardContext } from 'contexts/CardContext';
import { useContactLinkContext } from 'contexts/ContactLinkContext';
import { v4 as uuidv4 } from 'uuid';

const MyCardsContainer = ({ user }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const tempCardId = uuidv4();
  const navigate = useNavigate();
  const location = useLocation();
  const { clearAllContactLinksData } = useContactLinkContext();

  // Notification state
  const [notification, setNotification] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  // Check for notification data passed from navigation
  useEffect(() => {
    if (location.state?.notification) {
      setNotification({
        open: true,
        message: location.state.notification.message,
        severity: location.state.notification.severity
      });

      // Clear the state so it doesn't show again on refresh/navigation
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  const handleNotificationClose = () => {
    setNotification({ ...notification, open: false });
  };

  const handleCreateCardClick = () => {
    console.log('Create New Card clicked!');
    // ✅ FIXED: Clear contact link context before starting new card creation
    clearAllContactLinksData();
    console.log('🔍 MyCardsContainer: Cleared contact link context for new card creation');
    navigate(`/dashboard/mycards/add-card/${tempCardId}`);
  };

  const handleEditCardClick = (card) => {
    console.log('Card Object:', card);
    navigate(`/dashboard/mycards/edit/${card._id}`);
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
  };

  return (
    <div>
      <MyCardsNavbar onSearch={handleSearch} />
      <ProgressUI />
      <CardsContainer
        user={user}
        onCreateCardClick={handleCreateCardClick}
        onEditCardClick={handleEditCardClick}
        searchQuery={searchQuery}
      />

      {/* Notification Snackbar */}
      <NotificationSnackbar
        open={notification.open}
        message={notification.message}
        handleClose={handleNotificationClose}
        severity={notification.severity}
      />
    </div>
  );
};

export default MyCardsContainer;